import { IAllocationDimensionValue } from "helpers/allocation-dimension";

export type HandleProcessedSuccessfullyProps = {
    doorAttributesData: IAttributeData[];
    readOnlyAttributes: string[];
};

export type UnitByDoor = Record<number, number>;

export type DoorsValueGroupedById = Record<string, { row: IAllocationDimensionValue; rowIndex: number }>;

export type DoorsForDisableOrEnable = { id: number; name: string; in_assortment?: boolean };

export type DoorForDisableOrEnableWithUnits = DoorsForDisableOrEnable & {
    units: number;
};

export type IAttributeDataChanges = {
    columnsToCreate: string[];
    columnsToUpdate: string[];
    columnsHeadersMap?: Map<string, string>;
    doorsForDisableOrEnable: DoorsForDisableOrEnable[];
    doorsForDisableOrEnableWithUnits: DoorForDisableOrEnableWithUnits[];
};

// An interface for our state
export type UploaderProviderLocalState = {
    changes: IAttributeDataChanges;
    errors: {
        messages?: IAttributeDataError;
    };
    feedbackUpload: {
        isUploading: boolean;
        wasProcessed: boolean;
    };
    feedbackUpdatingData: {
        isUpdating: boolean;
        wasUpdated: boolean;
    };
};

export type UploaderContextValues = {
    handleDrop?: (file: File, onSettled: (error: boolean) => void) => Promise<void>;
    handleCancelChanges?: () => void;
    handleConfirmChanges?: () => void;
    handleOpenConfirmDialog?: () => void;
    handleClickOk?: () => void;
    clearValueStates?: () => void;
    handleClearErrors?: () => void;

    errorMessages: IAttributeDataError;
    wasUpdated: boolean;
    isUploading: boolean;
    isUpdating: boolean;
    wasProcessed: boolean;

    isOpenDialogToConfirmChanges: boolean;
    hasDataToChange: boolean;

    columnsToCreate: string[];
    columnsToUpdate: string[];
    columnsHeadersMap?: Map<string, string>;
    doorsForDisableOrEnable: string[];
    doorsForEnableWithUnits: string[];
    doorsForDisableWithUnits: string[];
};

export interface IAttributeData {
    [key: string]: string;
}

export enum RuleType {
    AttributeAlreadyExistsRule = "attribute-already-exists-rule",
    AttributeIsReadonlyRule = "attribute-is-readonly-rule",
    AttributeIsFreeformRule = "attribute-is-freeform-rule",
    AttributeValidNameRule = "attribute-valid-name-rule",
    BooleanInAssortmentValueRule = "boolean-in-assortment-value-rule",
    MaxCustomAttributesRule = "max-custom-attributes-rule",
    NoDuplicateRowRule = "no-duplicate-row-rule",
    NotEmptyRule = "not-empty-rule",
    OnlyExistingDoorsRule = "only-existing-doors-rule",
    RequiredColumnsRule = "required-columns-rule",
    UseAlternativeId = "use-alternative-id",
    CustomAttributesDisabled = "custom-attributes-disabled",
    AttributeNameLengthRule = "attribute-name-length-rule",
}

export type IAttributeDataError = {
    [RuleType.AttributeAlreadyExistsRule]?: string[];
    [RuleType.AttributeIsReadonlyRule]?: string[];
    [RuleType.AttributeValidNameRule]?: string;
    [RuleType.BooleanInAssortmentValueRule]?: string;
    [RuleType.MaxCustomAttributesRule]?: string;
    [RuleType.NoDuplicateRowRule]?: string;
    [RuleType.NotEmptyRule]?: string;
    [RuleType.OnlyExistingDoorsRule]?: string;
    [RuleType.RequiredColumnsRule]?: string;
    [RuleType.UseAlternativeId]?: string;
    [RuleType.CustomAttributesDisabled]?: string;
    [RuleType.AttributeNameLengthRule]?: string;
};

export type IImportDataError = {
    string?: string;
};
